import React from 'react';
import { Text } from '@atlaskit/primitives';
import { CellWrapper } from '@atlassian/jira-admin-pages-issue-types-common/src/ui/index.tsx';
import { Description, NameWrapper } from './styled';

export type Props = {
	name: string;
	description: string;
	iconUrl: string;
};

export const NameCell = ({ name, description, iconUrl }: Props) => (
	<CellWrapper first>
		<NameWrapper>
			{/* @ts-expect-error - TS2322 - Type '{ src: string; alt: string; align: string; }' is not assignable to type 'DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>'. */}
			<img src={iconUrl} alt="" align="absmiddle" />
			<Text as="strong">{name}</Text>
		</NameWrapper>
		<Description>{description}</Description>
	</CellWrapper>
);
